/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   getQueryMinPrice
 */

import type {
  Filters,
  FloorplanListing,
  Listable,
  NormalFloorplanListingData,
  Property,
} from '@zcode/state-type'
import { groupFloorplansByBedsBaths } from '../helpers'

import { getQueryBuildingMinPrice } from './getQueryBuildingMinPrice'
import { getQueryListingMinPrice } from './getQueryListingMinPrice'

export const getQueryMinPrice = ({
  entity,
  filters,
  floorplan,
}: {
  entity: Listable | Property
  filters: Partial<Filters> | undefined
  floorplan?: FloorplanListing<NormalFloorplanListingData> | null | undefined
}) => {
  const { floorplans: entityFloorplans, isBuilding, isFloorplan } = entity

  if (isBuilding && !isFloorplan) {
    if (floorplan) {
      const floorplansByBedsBaths = groupFloorplansByBedsBaths(entityFloorplans)
      const { minPrice } = floorplansByBedsBaths.get(floorplan.bedsBathsTxt) ?? {}

      return getQueryListingMinPrice({
        price: minPrice,
        filters,
      })
    }

    return getQueryBuildingMinPrice({
      price: entity.minPrice || entity.price,
      filters,
    })
  }

  return getQueryListingMinPrice({
    price: entity.minPrice || entity.price,
    filters,
  })
}
